import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ResourceStatusCollection,
  ResourceStatusResponse,
} from '@thiememeulenhoff/types';
import { ResourceStatusEndpointService } from './resource-status.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class ResourceStatusService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ResourceStatusEndpointService);

  fetchGroupResourceStatus(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
  ) {
    const endpoint = this.#endpoints.groupResourceStatus(
      groupCode,
      arrangementCode,
    );

    if (!contentIdentifier || contentIdentifier === '') {
      throw new Error(
        'contentIdentifier is required for fetching resource status',
      );
    }

    const params = { contentIdentifier };

    return this.#http.get<Array<ResourceStatusResponse>>(endpoint, {
      params,
    });
  }

  storeResourceStatuses(
    arrangementCode: string,
    collection: ResourceStatusCollection,
  ) {
    const endpoint = this.#endpoints.storeResourceStatus(arrangementCode);

    return this.#http.post(endpoint, collection);
  }
}
